module.exports = __webpack_public_path__ + "img/6.31fb2cc3.png";